import { asyncRoutes, constantRoutes } from '@/router/_router'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(pers, route) {
  if (route.meta && route.meta.permission) {
    return pers.some(per => route.meta.permission.includes(per))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, pers) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(pers, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, pers)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }, pers) {
    return new Promise(resolve => {
      let accessedRoutes = filterAsyncRoutes(asyncRoutes, pers)
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
